import { HttpResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import * as globals from './globals';
import { Injectable } from '@angular/core';
import { VolatileStorage } from './storage/volatile-storage';
import { Preference } from './storage/preference';
import { AuthenticationResult, SessionInfo } from './data/authentication-info';
import { Observable, throwError } from 'rxjs';
import * as Rx from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { isPresent } from './providers/common-service';
/**
 * Created by Ashok on 06-04-2016.
 */
@Injectable()
export class AuthenticationService {
    public static CurrentUser: string = "CurrentUser";
    private curUser: any;

    constructor(private http: HttpClient,
        private preference: Preference,
        private volatileStorage: VolatileStorage) {

        preference.getPref(AuthenticationService.CurrentUser)
            .subscribe((data: any) => {
                this.curUser = data;
            })
    }

    /**
     * Checks whether currently signed in or not
     * @returns {boolean} Returns true if signed in and session info exist
     */
    isSignedIn(): boolean {
        let session: SessionInfo = this.volatileStorage.getObject("session");
        return isPresent(session) && isPresent(session.authToken);
    }

    currentUser(): Observable<any> {
        return this.preference.getPref(AuthenticationService.CurrentUser);
    }

    /**
     * Gets the current user from the storage. The current user is one who logged in
     * last
     * @param subscriber The retrieval of current user is asynchronous process.
     * Pass the
     */
    getCurrentUser(): any {
        return this.curUser;
    }

    /**
     * Gets the current session information for the logged in user
     * @returns {SessionInfo} The session info object
     */
    // currentSession(): SessionInfo {
    //     return this.volatileStorage.getObject("session");
    // }

    authenticatePlayer(username: string, password: string): Observable<SessionInfo> {
        let creds = "email=" + username + "&" + "password=" + password + "&username=" + username;
        const headers = new HttpHeaders().set(
            'Content-Type',
            'application/x-www-form-urlencoded'
        );

        // this.http.get('https://example.com/api/items').pipe(map(data => {})).subscribe(result => {

        // })

        return this.http.post(globals.ServerUrls.authentication, creds, {
            headers: headers
        }).pipe(map((res: any) => {
            let data: AuthenticationResult = res.json();
            let sessionInfo: SessionInfo = {
                authToken: data.authToken,
                userId: data.user.userId,
                userName: username,
                password: password,
                userType: data.user.userType,
                playerId: data.user.playerId,
                clubId: data.user.clubId,
                organizerId: data.user.organizerId,
                name: data.name,
                admin: data.user.admin,
            }
            this.volatileStorage.setObject("session", sessionInfo);
            this.volatileStorage.setBoolean("authenticated", true);
            // //Store the current user in preference so that it can be
            // //used for auto login next time
            let curUser = {
                username: username,
                password: password
            }
            this.preference.setPref(AuthenticationService.CurrentUser, curUser);
            this.curUser = curUser;
            //Call the subscriber
            return sessionInfo;
        }))
    }

    authenticate(userName: string, password: string, appType?: string): Observable<AuthenticationResult> {
        let creds = "email=" + userName + "&" + "password=" + password + "&username=" + userName;
        let _clubId = globals.clubId;
        let _params = {};
        let _validateClubMember = true;
        let _url: string;
        _url = globals.ServerUrls.newAuthentication;
        let _hdrs = {};
        if (globals.appType === 'club' && globals.clubId && appType === 'play') {
            creds += "&clubId=" + _clubId + "&validateClubMember=" + _validateClubMember;
            // creds = "clubId=" + _clubId + "&validateClubMember=" + _validateClubMember + "&" + creds;
            _url = globals.ServerUrls.newAuthentication;
            _params = {
                email: userName,
                password: password,
                username: userName,
                clubId: _clubId,
                validateClubMember: _validateClubMember
            }
            _hdrs["Accept"] = "application/json";
        } else if (appType === 'club') {
            _url = globals.ServerUrls.newAuthentication;
            _params = {
                email: userName,
                password: password,
                username: userName,
                // clubId: _clubId,
                // validateClubMember: _validateClubMember
            }
            _hdrs["Accept"] = "application/json";
        }
        else {
            // _url = globals.ServerUrls.authentication;
            _url = globals.ServerUrls.newAuthentication;
            _params = {
                email: userName,
                password: password,
                username: userName
            }
        }
        const headers = new HttpHeaders().set(
            'Content-Type',
            'application/x-www-form-urlencoded'
        );
        // globals.ServerUrls.authentication
        return this.http.post(_url, creds, {
            headers: headers
        }).pipe(map((res: any) => {
            let data: AuthenticationResult = res;
            return data;
        }));
    }

    public setCurrenUser(email: string) {
        this.signout();
        let curUser = {
            username: email
        }
        this.curUser = curUser;
        this.preference.setPref(AuthenticationService.CurrentUser, curUser);
    }

    /**
     * Signout the session. This will clear session and clears the current user password
     */
    public signout() {


        this.volatileStorage.remove("session");
        this.volatileStorage.remove("authenticated");


        // this.preference.clearUserPreference("CompetitionFilter")
        this.preference.setPref("ScorecardSearchFilter");
        this.preference.setPref("ScorecardSearchScorecardType");
        this.preference.setPref("CompetitionFilter");

        // this.pref.setPref("ScorecardSearchFilter");
        // this.pref.setPref("ScorecardSearchScorecardType");
        this.preference.clearUserPreference("ScorecardSearchFilter");
        this.preference.clearUserPreference("ScorecardSearchScorecardType");
        this.preference.clearUserPreference("CompetitionFilter");

        this.preference.getPref(AuthenticationService.CurrentUser)
            .subscribe((curUser: any) => {
                if(curUser?.password)
                  curUser.password = '';
                this.curUser = curUser;
                this.preference.setPref(AuthenticationService.CurrentUser, curUser);
            });

    }

    private handleError(error) {
        let result: any;
        if (error && error.json) {
            result = error.json();
        } else if (error) {
            result = error;
        } else {
            result = "Server error occured";
        }
        return throwError(result);
    }
}
